import React from "react";
import {
  AlertTriangle,
  Inbox,
  LockKeyhole,
} from "lucide-react";
import { useLanguage } from "../../localization/LanguageContext";
import "./StatePanel.css";

const DEFAULT_LABELS = {
  empty: "No data",
  loading: "Loading",
  error: "Something went wrong",
  permission: "Access protected",
};

const DEFAULT_ICONS = {
  empty: Inbox,
  error: AlertTriangle,
  permission: LockKeyhole,
};

export function StatePanel({
  kind = "empty",
  title,
  description,
  icon,
  actions,
  compact = false,
  className = "",
}) {
  const { copy } = useLanguage();
  const isLoading = kind === "loading";
  const role = kind === "error" ? "alert" : "status";
  const DefaultIcon = DEFAULT_ICONS[kind];

  return (
    <div
      className={["crm-state-panel", className].filter(Boolean).join(" ")}
      data-kind={kind}
      data-compact={compact ? "true" : undefined}
      role={role}
      aria-live={kind === "error" ? "assertive" : "polite"}
      aria-busy={isLoading || undefined}
    >
      <div className="crm-state-panel__icon" aria-hidden="true">
        {isLoading ? (
          <span className="crm-state-panel__spinner" />
        ) : (
          icon || (DefaultIcon ? <DefaultIcon size={21} strokeWidth={1.9} /> : <span>i</span>)
        )}
      </div>
      <div className="crm-state-panel__copy">
        <h2>{typeof title === "string" ? copy(title) : title || copy(DEFAULT_LABELS[kind] || DEFAULT_LABELS.empty)}</h2>
        {description && <p>{typeof description === "string" ? copy(description) : description}</p>}
      </div>
      {actions && <div className="crm-state-panel__actions">{actions}</div>}
    </div>
  );
}

export const EmptyState = (props) => <StatePanel kind="empty" {...props} />;
export const LoadingState = (props) => <StatePanel kind="loading" {...props} />;
export const ErrorState = (props) => <StatePanel kind="error" {...props} />;
